import type {Table as ReactTable} from '@tanstack/react-table';

import TableListView from '@/components/data-table/TableListView';
import type {PaperProps} from '@/components/ui/paper';
import type {Event} from '@/services/graphqlHooks';

import EventListItem from './EventListItem';

interface EventListViewProps {
  table: ReactTable<Event>;
  paperProps?: Omit<PaperProps, 'children'>;
  readOnly?: boolean;
}

const EventListView = ({table, paperProps, readOnly}: EventListViewProps) => {
  return (
    <TableListView className="grow">
      {table
        .getRowModel()
        .rows?.map(row => (
          <EventListItem
            id={row.getValue('id')}
            type={row.getValue('type')}
            eventSubType={row.getValue('eventSubType')}
            content={row.getValue('content')}
            date={row.getValue('date')}
            pairingId={row.getValue('pairingId')}
            key={row.id}
            resident={row.getValue('resident')}
            user={row.getValue('user')}
            isSharedToAuthorizedRelative={row.getValue(
              'isSharedToAuthorizedRelative'
            )}
            paperProps={paperProps}
            readOnly={readOnly}
          />
        ))}
    </TableListView>
  );
};

export default EventListView;
